export function SectionHeader({ text }: { text: string }) {
    return <h1 className="text-3xl text-gray-900 mb-4 mt-10">{text}</h1>;
}
